import { playerMovementSystem } from './playerMovementNetcode';
import { emptyTemplate } from './empty';
import { SandboxTemplate, SandboxSystems } from './types';

export * from './types';

export const TEMPLATES: SandboxTemplate[] = [
  playerMovementSystem,
  emptyTemplate,
];

// Default template (first one in the list)
export const DEFAULT_TEMPLATE = TEMPLATES[0];
export const DEFAULT_SYSTEMS: SandboxSystems = DEFAULT_TEMPLATE.systems;